export class FGBLocalStorage {
    static removeItem = (key) => {
        if (!window || !window.localStorage) {
            return null;
        }
        const myStorage = window.localStorage;
        myStorage.removeItem(key);
        return null;
    };

    static getItem = (key) => {
        if (!window || !window.localStorage) {
            return null;
        }
        const myStorage = window.localStorage;
        let item = null;
        try {
            item = JSON.parse(myStorage.getItem(key));
        } catch (e) {
            console.error('unable to get storageItem', e);
        }

        return item;
    };

    static setItem = (key, item) => {
        const myStorage = window.localStorage;

        if (!window || !window.localStorage) {
            return null;
        }

        if (key === 'companyAds') {
            const savedItems = FGBLocalStorage.getItem(key);
            const uniqueItems = new Set(savedItems);
            uniqueItems.add(item);

            const arrayItems = Array.from(uniqueItems);

            while (arrayItems.length > 2) {
                arrayItems.shift();
            }
            return myStorage.setItem(key, JSON.stringify(arrayItems));
        }
        return myStorage.setItem(key, JSON.stringify(item));
    };
}
